import { useParams } from 'react-router';
export const useRequiredParams = () => {
    const params = useParams();
    for (const key in params) {
        if (!params[key]) {
            throw new Error(`Required parameter "${key}" is missing`);
        }
    }
    return params;
};
